import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../theme';
const useLoaderClasses = createUseStyles({
    '@keyframes spin': {
        from: {
            transform: 'rotate(0deg)',
        },
        to: {
            transform: 'rotate(360deg)',
        },
    },
    loader: (props) => ({
        color: props.color ? props.theme.colors[props.color] : undefined,
        animation: '$spin 0.54s linear infinite',
        fill: 'currentColor',
        width: props.size,
        height: props.size,
    }),
});
export const Loader = ({ size = `1.5rem`, color, ...props }) => {
    const theme = useTheme();
    const classes = useLoaderClasses({ size, color, theme });
    return (React.createElement("svg", { className: classes.loader, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props },
        React.createElement("path", { d: "M16,30.3c-3.8,0.1-7.6-1.3-10.4-3.9C2.8,23.8,1.1,19.9,1,16C0.8,12.1,2.3,8,5.1,5.1C7.9,2.2,11.9,0.4,16,0.3\n                  l0,0c0.8,0,1.4,0.6,1.5,1.4s-0.6,1.4-1.4,1.5c0,0-0.1,0-0.1,0C12.6,3,9.2,4.3,6.6,6.6C4.1,9,2.5,12.4,2.4,16\n                  c-0.1,3.6,1.2,7.2,3.7,9.9C8.6,28.5,12.2,30.2,16,30.3z" })));
};
